module.exports = __webpack_public_path__ + "static/9-179e95a0b2eb5652b5c3ca7833d72fb9.jpg";